import { HH, mm } from '../interfaces/Time';

export const parseReminderTime = (hours: HH | null, minutes: mm | null) => {
    return hours === null && minutes === null ?
        null : (hours ?? '00') + ':' + (minutes ?? '00');
};

export const getTimeReminderTime = (reminderTime: string | null | undefined) => ({
    hours: (reminderTime?.slice(0, 2) ?? null) as HH | null,
    minutes: (reminderTime?.slice(3, 5) ?? null) as mm | null,
});


export const setReminderTimeObject = (hours: HH | null, minutes: mm | null) => {
    return hours === null && minutes === null ?
        { hours, minutes }
        :
        { hours: hours ?? '00', minutes: minutes ?? '00' };
};

export const getDefaultTimerMiliSeconds = () => {
    const configSeconds = window.config.TIMER_SECONDS;
    if (!configSeconds || typeof configSeconds !== 'number' || configSeconds < 1) return 60000;
    return configSeconds * 1000;
}